import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import Modal from '@medflex/components/stories/Modal';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import { trackEvent } from '@medflex/utils/Tracking';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';
import useSessionMeetings from '../hooks/useSessionMeetings';
import useModal from '../hooks/useModal';

const SessionsCancelModule = () => {
  const { t } = useTranslation('global');
  const { close } = useModal();
  const { sessionId } = useLocationSearchParams();
  const { errors, cancel, isLoading, getMeetingById, getDateFormatted } = useSessionMeetings();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const meeting = getMeetingById(sessionId);
  const dateFormatted = getDateFormatted(meeting && meeting.scheduledAt);

  const handleClose = () => {
    close({ modal: 'sessionsCancel', sessionId });
  };

  const handleSubmit = event => {
    cancel({ id: sessionId });
    trackEvent(event, { actionText: 'cancelSession' });
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (isSubmitted && !isLoading) {
      if (!errors.update) {
        showSuccessToast(t('sessions.SessionsCancelModule.success'), null, {
          toastId: 'sessionCancelSuccess',
        });
        handleClose();
        return;
      }
      showAlertToast(
        t('sessions.SessionsCancelModule.failureTitle'),
        t('sessions.SessionsCancelModule.failureDescription'),
        {
          toastId: 'sessionCancelFailed',
        },
      );
      setIsSubmitted(false);
    }
  }, [errors, isSubmitted, isLoading]);

  if (!meeting) {
    return null;
  }

  return (
    <Modal
      title={t('sessions.SessionsCancelModule.title')}
      onClickCloseButton={handleClose}
      onClickOutside={handleClose}
      showCloseButton
    >
      <div data-component="SessionsCancelModule" className="flex flex-col">
        <p className="mb-4">
          {t('sessions.SessionsCancelModule.textConfirmation', {
            title: meeting.title,
            date: dateFormatted,
            allowHtml: true,
          })}
        </p>
        <p className="mb-6">{t('sessions.SessionsCancelModule.participantNotification')}</p>
        <Button className="self-center" isLoading={isLoading} onClick={handleSubmit}>
          {t('sessions.SessionsCancelModule.submit')}
        </Button>
      </div>
    </Modal>
  );
};

export default SessionsCancelModule;
